var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUnPinIcon = function SvgUnPinIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5628 8.89527C4.42034 8.97885 4.29895 9.094 4.20796 9.23184C4.11697 9.36969 4.05881 9.52657 4.03795 9.69041C4.01708 9.85426 4.03408 10.0207 4.08762 10.177C4.14116 10.3332 4.22982 10.4751 4.34679 10.5917L10.2606 16.5055C10.3772 16.6225 10.5191 16.7112 10.6754 16.7647C10.8316 16.8182 10.9981 16.8352 11.1619 16.8144C11.3257 16.7935 11.4826 16.7353 11.6205 16.6443C11.7583 16.5534 11.8735 16.432 11.957 16.2895C12.6575 15.0844 12.8664 13.6556 12.5403 12.3004L17.2415 9.30858C17.378 9.22178 17.4932 9.10545 17.5787 8.96816C17.6642 8.83087 17.7178 8.67614 17.7355 8.51538C17.7532 8.35462 17.7345 8.19194 17.6809 8.03934C17.6274 7.88675 17.5402 7.74813 17.4259 7.63373L13.2186 3.42646C13.1042 3.3121 12.9657 3.22488 12.8131 3.17123C12.6605 3.11759 12.4979 3.09889 12.3371 3.11651C12.1764 3.13413 12.0216 3.18763 11.8843 3.27306C11.747 3.35848 11.6306 3.47365 11.5437 3.61007L8.5519 8.31203C7.19669 7.98589 5.76791 8.19479 4.5628 8.89527V8.89527Z",
    strokeWidth: 1.17827,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30361 13.549L1.54102 19.3115",
    strokeWidth: 1.17827,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8087 18.7367L2.11883 0.999997",
    strokeWidth: 1.17827,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnPinIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/UnPinIcon.2432573e.svg";
export { ForwardRef as ReactComponent };